import { render, staticRenderFns } from "./PreviewCode.vue?vue&type=template&id=1886c76b&scoped=true"
import script from "./PreviewCode.vue?vue&type=script&lang=js"
export * from "./PreviewCode.vue?vue&type=script&lang=js"
import style0 from "./PreviewCode.vue?vue&type=style&index=0&id=1886c76b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1886c76b",
  null
  
)

export default component.exports